export default {
  settings: 'Settings',
  settingsSubtitle: 'Change settings for Lunch App.',
  preferredLanguage: 'Preferred Language',
  city: 'City',
  appearance: 'Appearance',
  appearanceSubtitle: 'Change Colors of User Interface according to your preference.',
  displayName: 'Display Name',
  primary: 'Primary',
  secondary: 'Secondary',
  info: 'Info',
  error: 'Error',
  manageUsers: 'Manage Users',
  searchByName: 'Search for user by name',
  userEditing: 'User Editing',
  displayname: 'Display Name',
  admin: 'Admin',
  active: 'Active',
  inactive: 'Inactive',
  updatedUser: 'User was updated successfully.',
  disableFancyOrderNotifications: 'Disable "fancy" order notifications.',
  dailyStartHour: 'Default hour for daily lunch',
  dailyStartDay: 'Default day for daily lunch',
  fridayStartHour: 'Default hour for friday lunch',
  fridayStartDay: 'Default day for friday lunch',
  ordersWithoutDepositDate: 'Order without deposit date',
  ordersWithoutDeposit: 'Order without deposit',
  ordersWithoutDepositUndoText:
    'User {displayName} can always order without deposit. Are you sure you want to undo this and allow to order without deposit only for specific date?',
};
